/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDevices} from '../api'

 export const useQueryGetDevices = createReactQueryHook('getDevices', getDevices)
